export const ROOMS_URL = `${process.env.REACT_APP_BACK_SHEET}/rooms`

export const ROOMS_GET_ALL = {
  url: ROOMS_URL,
  method: 'GET',
}
